// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./core/vue/css/product_search.css
// module id = 882
// module chunks = 15